export const PROFILE_GET = "profileGet";
export const PROFILE_DAYS_OFF_GET = "profileDaysOffGet";
export const PROFILE_UPDATE = "profileUpdate";
export const PROFILE_LOGO_GET = "profileLogoGet";
export const PROFILE_LOGO_SAVE = "profileLogoSave";
export const PROFILE_ADD_DAY_OFF = "profileAddDayOff"
export const PROFILE_DELETE_DAY_OFF = "profileDeleteDayOff"
export const PROFILE_INACTIVE = "profileInactive" 
export const PROFILE_ACTIVE = "profileActive"